module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "pub_dialog",
    attrs: {
      "visible": _vm.isBusinessQuotation,
      "width": "96%",
      "top": "50px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isBusinessQuotation = $event
      },
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v("询价单: " + _vm._s(_vm.getInquiryNo))])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawerInformation"
  }, [_c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    },
    attrs: {
      "label": "竞　价　品　类："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    on: {
      "change": _vm.getbrandarr
    },
    model: {
      value: (_vm.formInline.brandTypeIds),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "brandTypeIds", $$v)
      },
      expression: "formInline.brandTypeIds"
    }
  }, _vm._l((_vm.biddingCategory), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    },
    attrs: {
      "label": "竞　价　品　牌："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.formInline.brandIds),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "brandIds", $$v)
      },
      expression: "formInline.brandIds"
    }
  }, _vm._l((_vm.competitiveBrands), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("报价商品")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "GoodsName",
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "请输入商品名称",
            "maxlength": "20"
          },
          model: {
            value: (scope.row.GoodsName),
            callback: function($$v) {
              _vm.$set(scope.row, "GoodsName", $$v)
            },
            expression: "scope.row.GoodsName"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GoodsCode",
      "label": "商品型号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "请输入商品型号",
            "maxlength": "20"
          },
          model: {
            value: (scope.row.GoodsCode),
            callback: function($$v) {
              _vm.$set(scope.row, "GoodsCode", $$v)
            },
            expression: "scope.row.GoodsCode"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "StyleId",
      "label": "风格",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.StyleId),
            callback: function($$v) {
              _vm.$set(scope.row, "StyleId", $$v)
            },
            expression: "scope.row.StyleId"
          }
        }, _vm._l((_vm.tBDStyle), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.Name,
              "value": item.Id
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "UnitId",
      "label": "单位",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.UnitId),
            callback: function($$v) {
              _vm.$set(scope.row, "UnitId", $$v)
            },
            expression: "scope.row.UnitId"
          }
        }, _vm._l((_vm.tBDUnit), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.Name,
              "value": item.Id
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参考图片/图纸",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#F56C6C"
          },
          on: {
            "click": function($event) {
              return _vm.endUploadPicture(scope.row)
            }
          }
        }, [_vm._v("上传(" + _vm._s(scope.row.Imgs ? scope.row.Imgs.length : 0) + "/5)")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Counts",
      "label": "数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "请输入数量",
            "maxlength": "5",
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "type": "text",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          model: {
            value: (scope.row.Counts),
            callback: function($$v) {
              _vm.$set(scope.row, "Counts", $$v)
            },
            expression: "scope.row.Counts"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "UnitPrice",
      "label": "单价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "请输入单价",
            "maxlength": "9",
            "type": "text",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          model: {
            value: (scope.row.UnitPrice),
            callback: function($$v) {
              _vm.$set(scope.row, "UnitPrice", $$v)
            },
            expression: "scope.row.UnitPrice"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注说明",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "请输入备注",
            "maxlength": "50"
          },
          model: {
            value: (scope.row.Remark),
            callback: function($$v) {
              _vm.$set(scope.row, "Remark", $$v)
            },
            expression: "scope.row.Remark"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.$index == _vm.tableData.length - 1) ? _c('el-button', {
          staticStyle: {
            "margin": "6px 3px"
          },
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": _vm.addLine
          }
        }, [_vm._v(" 添加")]) : _vm._e(), _vm._v(" "), (_vm.tableData.length > 1) ? _c('el-button', {
          staticStyle: {
            "margin": "6px 3px"
          },
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v(" 删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('span', [_c('strong', [_vm._v("总计：")])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.hejishuliang))])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.hejidanjia))])]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.zonghe))])])]), _vm._v(" "), _c('div', {
    staticClass: "labelInput"
  }, [_c('label', [_vm._v("竞标价:　")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "Number",
      "placeholder": "请输入最终竞标价",
      "maxlength": "9",
      "oninput": "value=value.replace(/[^\\d^\\.]/g,'')",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.purchasingPrice),
      callback: function($$v) {
        _vm.purchasingPrice = $$v
      },
      expression: "purchasingPrice"
    }
  }), _vm._v(" "), _c('label', [_vm._v("　平台佣金: "), _c('strong', [_vm._v(_vm._s((_vm.pingtaiyongjin * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('label', [_vm._v("　平台应得佣金: "), _c('strong', [_vm._v("¥ " + _vm._s(_vm.zuizhongJbj))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("报价要求")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "报价有效截止日期："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "editable": false,
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerStartDate,
      "placeholder": "选择有效截止日期"
    },
    on: {
      "change": function($event) {
        return _vm.seedata()
      }
    },
    model: {
      value: (_vm.EffectDate),
      callback: function($$v) {
        _vm.EffectDate = $$v
      },
      expression: "EffectDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-left": "30px"
    },
    attrs: {
      "label": "计划送货截止日期："
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("付款")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请输入",
      "oninput": "value=value.replace(/[^\\d]/g,'')"
    },
    model: {
      value: (_vm.DeliveryDate),
      callback: function($$v) {
        _vm.DeliveryDate = $$v
      },
      expression: "DeliveryDate"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("天后送货")])], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('p', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("备注：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "80%",
      "word-wrap": "break-word"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入其他事项以及其他收费款项标准",
      "maxlength": "150"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-top": "10px"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.contract()
      }
    }
  }, [_vm._v("报价协议")])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "drawer_foot"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isBusinessQuotation = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SubmitQuoteButton),
      expression: "SubmitQuoteButton"
    }],
    attrs: {
      "type": "danger",
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.submitQuotation
    }
  }, [_vm._v("提交报价")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ModifyQuoteButton),
      expression: "ModifyQuoteButton"
    }],
    attrs: {
      "type": "danger",
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.cliModifyQuotation
    }
  }, [_vm._v("修改报价单")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isPicture,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isPicture = $event
      },
      "close": _vm.closeUpload
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v("上传" + _vm._s(_vm.flag) + "张图片")]), _vm._v(" "), _c('li', [_c('el-button', {
          staticStyle: {
            "margin-top": "-10px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.closeUpload
          }
        }, [_vm._v("关 闭")])], 1)])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawerPicdiv"
  }, [_c('div', {
    staticClass: "upPictures"
  }, [_vm._l((_vm.detailImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "block",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "float": "left",
        "margin-right": "10px"
      },
      attrs: {
        "data-img": item
      }
    }, [_c('div', {
      staticClass: "tuimg",
      staticStyle: {
        "float": "left",
        "margin-right": "10px",
        "margin-top": "5px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deldetail(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png"),
        "alt": ""
      }
    })])], 1)])
  }), _vm._v(" "), (_vm.flag < 5) ? _c('el-upload', {
    attrs: {
      "action": "",
      "multiple": "",
      "list-type": "picture-card",
      "before-upload": _vm.beforeAvatarUpload,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "preservation_div"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeUpload
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.endConfirmUpload
    }
  }, [_vm._v("确认")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-edef5eea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderManagement/BusinessQuotation.vue
// module id = 1752
// module chunks = 3